"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPickerSliderButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
const ColorPickerSliderButton = (0, _styled.default)("div")`
    width: 26px;
    height: 26px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 4px solid ${(0, _designTokensReact.color)("color--border--surfaces--body")};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 0;
    margin: 0 -13px;
    pointer-events: none;
`;
exports.ColorPickerSliderButton = ColorPickerSliderButton;
//# sourceMappingURL=ColorPickerSliderButton.js.map